// main.tsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.tsx";
import "../i18n";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  // Bruit de navigateurs tiers, pas notre code : le navigateur DuckDuckGo
  // (iOS) injecte ses propres scripts qui parlent a l'app native via
  // window.webkit.messageHandlers ; quand l'app ne repond pas, leur promesse
  // rejetee remonte en "unhandledrejection" sur notre page.
  ignoreErrors: [/WKWebView API client did not respond to this postMessage/],
});

// HeroUI charge framer-motion a la demande (chunk separe). Si un deploiement
// passe pendant qu'une page est ouverte, l'ancien chunk n'existe plus et
// Cloudflare Pages renvoie index.html a la place (fallback SPA) : le navigateur
// refuse alors le module ("text/html is not a valid JavaScript MIME type").
// On recharge pour recuperer la nouvelle version, au plus une fois par minute
// pour eviter une boucle si le chunk manque vraiment.
const PRELOAD_RELOAD_KEY = "widget:preload-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY));
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage inaccessible : sans garde-fou, on ne recharge pas.
    return;
  }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Sans ce filet, une erreur de rendu React laisse une page blanche sur le
    site du studio (cf. widget-config.ts) au lieu d'un message minimal. */}
    <Sentry.ErrorBoundary
      fallback={
        <p style={{ padding: 16, fontFamily: "sans-serif" }}>
          Une erreur est survenue. Merci de rafraîchir la page.
        </p>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
